export const messageEnum = {
  somethingWentWrong: "Something went wrong. Please try again later !!!",
  invalidEmail: "Please enter a valid Email Id",
  authenticationFailed: "Authentication failed: Invalid or expired token.",
  sessionExpired: "Session expired. Please login again.",
  authenticationRequired:
    "Authentication required: Missing or malformed Authorization header.",
  adminLoginSuccessfull: 'Login successful! Redirecting to Admin Dashboard'
};

export const applicationRole = {
  rescueRnAdmin: "admin",
  businessLeaders: "business-leader",
  coach: "coach",
  teamMember: "team-member",
};

export const organisationActionType = {
  add: "add",
  edit: "edit",
  view: "view",
  addOrganizationAdminUser: "addOrganizationAdminUser",
  addCoach: "addCoach",
  addTeam: "addTeam",
  performanceDashboard: "performanceDashboard",
}
export const individualOrganisationActionType = {
  addCoach: "addCoach",
  addTeamMember: "addTeamMember",
  editCoach: "editCoach",
  editTeam: "editTeam",
  viewCoach: "viewCoach",
  viewTeam: "viewTeam",
  sendCertificate: "sendCertificate",
  deleteCoach: "deleteCoach",
  deleteTeam: "deleteTeam",
  assignCourse: "assignCourse",
}
export const organizationPlanEnum = {
  code_prep: "Code Prep",
  rxn_ready: "RXN Ready"
};
export const resourceActionType = {
  delete: "delete",
  add: "add",
  download: "download",
}
